const steps = [
    {id: 1, title: 'About Recurring Billing', name: 'about'},
    {id: 2, title: 'Purchase', name: 'purchase'},
    {id: 3, title: 'Update', name: 'update'},
    {id: 4, title: 'ResponseCode', name: 'response_code'},
    {id: 5, title: 'Credential', name: 'credential'}
]

export default steps